// What a saved review needs from the treatment plan it was started from.
import type { AHTWeightTreatmentPlan } from "@/lib/ahtTreatmentPlanData";

export interface PlanReviewContext {
  planId: string;
  supplyEventId: string | null;
  patientId: string | null;
  initialWeightKg: number | null;
}

export function planReviewContext(plan: AHTWeightTreatmentPlan): PlanReviewContext {
  const last = plan.supplyHistory[plan.supplyHistory.length - 1];
  return {
    planId: plan.id,
    supplyEventId: last?.id ?? null,
    patientId: plan.patientId ?? null,
    initialWeightKg: Number.isFinite(plan.baselineWeightKg) && plan.baselineWeightKg > 0 ? plan.baselineWeightKg : null,
  };
}
